import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import { Button, Popover } from 'hljd'
import { isStoreAccount } from '@util'
import styles from './style.module.less'
import Item from './Item'
import { getText } from '../utils'

@inject('centerStore')
@observer
export default class extends Component {
  render() {
    const {
      centerStore: { handleSave, isDraft, isSingle, isEdit }
    } = this.props

    const type = getText(isSingle)
    return (
      <div className={styles.wrapprer}>
        <Item>
          <div className={styles.submitGroup}>
            <Button
              type="primary"
              className={styles.saveBtn}
              onClick={() => handleSave('save')}
            >
              发布{type}
            </Button>

            {!isStoreAccount() && (
              <>
                {(!isEdit || isDraft) && (
                  <Button
                    className={styles.draftBtn}
                    onClick={() => handleSave('draft')}
                  >
                    存为草稿
                  </Button>
                )}
              </>
            )}

            {isEdit && (
              <Popover
                content={
                  <DeletPopver
                    type={type}
                    centerStore={this.props.centerStore}
                  />
                }
                trigger="click"
              >
                <div className={styles.deleteWrapper}>
                  <div className={styles.delete}>删除{type}</div>
                </div>
              </Popover>
            )}
          </div>
        </Item>
      </div>
    )
  }
}

function DeletPopver(props) {
  const { type, centerStore } = props
  const { isDraft, detailData, deleteDraft, deleteSubmited } = centerStore

  const { is_sold_out, is_never_sold } = detailData

  let title = ''
  let deleteMethod = deleteSubmited
  const TEXT = getText()

  if (isDraft) {
    title = `确定删除草稿箱中的该${type}吗？`
    deleteMethod = deleteDraft
  } else if (is_never_sold) {
    // 从未上架
    title = `确定删除该${TEXT}？`
  } else if (is_sold_out) {
    // 已下架
    title = `该${TEXT}已下架，删除后若您再次发布，则需要重新审核，确定删除吗？`
  } else {
    // 已上架
    title = `该${TEXT}已上架，删除后顾客将无法访问该${TEXT}，确定删除吗？`
  }

  return (
    <div className={styles.deletPopver}>
      <div className={styles.content}>{title}</div>
      <div className={styles.buttons}>
        <Button
          type="primary"
          onClick={() => {
            deleteMethod()
          }}
          className={styles.deleteBtn}
        >
          删除
        </Button>
      </div>
    </div>
  )
}
